import React, { useContext, useEffect } from "react";
import { faBox, faBoxOpen, faBullseye, faComments, faFile, faGears, faUsers, faWandMagicSparkles } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';
import DynamicInput from "components/common/DynamicInput";
import { UserSettingsContext } from "contexts/UserSettingsContext";
import ApiError from "components/common/ApiError";
import { Circles } from "react-loader-spinner";
import { Col, Row } from "reactstrap";
import { useNavigate } from "react-router-dom";
import { APP_KEYS } from "constants";

export const APPS = [
    { value: APP_KEYS.CRM, label: 'menu.crm', icon: faUsers },
    { value: APP_KEYS.MARKETING, label: 'menu.marketing', icon: faBullseye },
    { value: APP_KEYS.SPEICHERFUCHS, label: 'menu.speicherfuchs', icon: faComments },
    { value: APP_KEYS.SAVVYSPEAK, label: 'menu.savvyspeak', icon: faFile },
    { value: APP_KEYS.OMS, label: 'menu.oms', icon: faBoxOpen },
    { value: APP_KEYS.TRAINING, label: 'menu.training', icon: faWandMagicSparkles },
    { value: APP_KEYS.SETTINGS, label: 'menu.settings', icon: faGears }
];

function AppSwitcher({ selectedApp, setSelectedApp }) {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const { apps, isLoadingApps, errorApps, refetchApps, currentUser } = useContext(UserSettingsContext);

    useEffect(() => {
        if(!isLoadingApps && !errorApps && apps?.length === 0){
            navigate(`/no-access`, { replace: false });
        }
    }, [apps]);

    if(!apps || isLoadingApps) return <Row className="justify-content-center align-items-center"><Col xs="auto"><Circles color="var(--bs-purple-pizzazz)" ariaLabel="loading animation" wrapperStyle={{ display: "block" }} wrapperClass="my-3" /></Col></Row>
    if(errorApps) return <ApiError retryFetch={refetchApps} errorMessage={errorApps.message}/>

    const visibleApps = APPS.filter(app => apps.items.map(a => a.name).includes(app.value));
    const currentApp = visibleApps.find(app => app.value === selectedApp) || visibleApps[0];

    console.log(apps)
    if(!currentApp)return null
    
    return (
        <div className="logo app-switcher d-flex align-items-center px-3">
            <DynamicInput 
                value={currentApp.value} 
                onChange={(e) => setSelectedApp(e.target.value)}
                type='iconSelect' 
                options={visibleApps}
                color="#FFFFFFCC"
                showText={false}/>
            <span className="ml-2 text-white font-weight-bold">
                {currentApp ? t(currentApp.label) : t('menu.unknown')}
            </span>
        </div>
    );
}

export default AppSwitcher;
